<template>
  <v-dialog v-model="internalVisible" max-width="500" persistent>
    <v-card class="text-center">
      <v-card-title>
        <v-avatar class="mx-auto" size="64" color="warning">
          <v-icon color="white" x-large>mdi-alert</v-icon>
        </v-avatar>
      </v-card-title>

      <v-card-text>
        <h3>{{ $t("generic.lang_sessionWarningTitle") }}</h3>
        <p>
          {{ $t("generic.lang_sessionAboutToExpire") }}<br />
          {{ $t("generic.lang_sessionStayLoggedIn") }}<br />
          {{ $t("generic.lang_timeLeft") }}: <strong>{{ countdown }}</strong>
          {{
            countdown === 1
              ? $t("generic.lang_second")
              : $t("generic.lang_seconds")
          }}
        </p>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn color="success" elevation="0" @click="stayLoggedIn">
          {{ $t("generic.lang_stay") }}
        </v-btn>
        <v-btn color="error" elevation="0" @click="logout">
          {{ $t("generic.lang_logout") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SessionWarningModal",
  props: {
    value: {
      type: Boolean,
      required: true
    },
    initialTime: {
      type: Number,
      default: 300 // 5 minutes
    }
  },
  data() {
    return {
      internalVisible: this.value,
      countdown: this.initialTime,
      timer: null
    };
  },
  watch: {
    value(val) {
      this.internalVisible = val;
      if (val) {
        this.startCountdown();
      } else {
        this.stopCountdown();
      }
    },
    internalVisible(val) {
      this.$emit("input", val); // sync back to parent
    },
    initialTime(newTime) {
      this.countdown = newTime;
    }
  },
  methods: {
    startCountdown() {
      this.countdown = this.initialTime;
      this.stopCountdown(); // clear any existing
      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          this.logout();
        } else {
          this.countdown--;
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async stayLoggedIn() {
      try {
        await this.$axios.post("/session/activity");
      } catch (e) {
        // ignore errors
      } finally {
        this.internalVisible = false; // Ensure the modal hides
      }
    },
    async logout() {
      try {
        await this.$axios.delete("/session/expire");
      } catch (e) {
        // ignore errors
      } finally {
        window.location.href = "/";
      }
    }
  },
  beforeDestroy() {
    this.stopCountdown();
  }
};
</script>
